import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { EDT_KEY } from '@teetsh/app/src/queries/edt/useEDTs';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';

export default function useDeleteEDT() {
  const { schoolyear, school } = useSchoolSchoolyear();
  const { notifyError } = useNotification();
  const queryClient = useQueryClient();
  const { t } = useTranslation(['emploiDuTemps']);
  const requestURL = `/schoolyears/${schoolyear.id}/schools/${school.id}/emplois-du-temps`;
  const { mutateAsync } = useMutation({
    mutationFn: ({ edtId }: { edtId: string }) =>
      request(`${requestURL}/${edtId}`, {
        method: 'DELETE',
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [schoolyear.id, school.id, EDT_KEY, 'list'],
      });
    },
    onError: () => {
      notifyError({
        title: t('emploiDuTemps:messages.edt.deleteError'),
      });
    },
  });
  return mutateAsync;
}
